import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type PartnerAttribution, PartnerAttributionApi } from '@/api-swagger'
import { useSuiteStore } from './useSuiteStore'

export const usePartnerAttributionStore = defineStore('partnerAttribution', () => {
  const loading = ref(false)
  const error = ref<string | null>(null)
  const api = new PartnerAttributionApi()
  const suiteStore = useSuiteStore()
  const partnerAttributions = ref<PartnerAttribution[] | null>(null) || []

  const getPartnerAttributionByPartnerId = async (partnerId: number) => {
    if (partnerId) {
      resetValues()
      loading.value = true
      try {
        const response = await suiteStore.suiteFetch(`partner_attribution/partner/${partnerId}`, { method: 'GET' })
        if (response && response.ok) {
          partnerAttributions.value = await response.json()
        } else {
          partnerAttributions.value = await api.getPartnerAttributionsByPartnerId({
            partnerId: partnerId,
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        loading.value = false
      }
    }
  }

  const getPartnerAttributionByUserId = async (userId: number) => {
    if (userId) {
      resetValues()
      loading.value = true
      try {
        partnerAttributions.value = await api.getPartnerAttributionsByUserId({ userId: userId })
      } catch (error) {
        console.error(error)
      } finally {
        loading.value = false
      }
    }
  }

  const getPartnerAttributionByCompanyId = async (companyId: number) => {
    if (companyId) {
      resetValues()
      loading.value = true
      try {
        partnerAttributions.value = await api.getPartnerAttributionsByCompanyId({
          companyId: companyId,
        })
      } catch (error) {
        console.error(error)
      } finally {
        loading.value = false
      }
    }
  }

  const resetValues = () => {
    partnerAttributions.value = []
    loading.value = false
    error.value = null
  }

  return {
    loading,
    error,
    partnerAttributions,
    getPartnerAttributionByPartnerId,
    getPartnerAttributionByUserId,
    getPartnerAttributionByCompanyId,
  }
})
